"use client"

import { useState } from "react"
import { useQueryClient } from "@tanstack/react-query"
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog"
import { AsyncButton } from "~/components/ui/async-button"
import { plansQueryKey } from "../hooks/use-plans"
import { cancelPending } from "../server/plans.functions"

type Kind = "payment" | "binding"

const COPY: Record<Kind, { title: string; description: string }> = {
  payment: { title: "Отменить платёж?", description: "Подписка не будет активирована." },
  binding: { title: "Отменить привязку карты?", description: "Текущая карта останется прежней." },
}

export function CancelPendingLink({ kind }: { kind: Kind }) {
  const [open, setOpen] = useState(false)
  const queryClient = useQueryClient()
  const { title, description } = COPY[kind]

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-sm text-destructive underline-offset-2 whitespace-nowrap"
      >
        Отменить
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent onDismiss={() => setOpen(false)}>
          <AlertDialogHeader>
            <AlertDialogTitle>{title}</AlertDialogTitle>
            <AlertDialogDescription>{description}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Назад</AlertDialogCancel>
            <AsyncButton
              variant="destructive"
              fn={() => cancelPending()}
              onSuccess={async () => {
                setOpen(false)
                await queryClient.invalidateQueries({ queryKey: plansQueryKey })
              }}
            >
              Отменить
            </AsyncButton>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
